import { render } from "./Copyright.vue?vue&type=template&id=600e8424&scoped=true"
import script from "./Copyright.vue?vue&type=script&lang=js"
export * from "./Copyright.vue?vue&type=script&lang=js"

import "./Copyright.vue?vue&type=style&index=0&id=600e8424&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-600e8424"

export default script